export default "/images/vendor/flag-icon-css/flags/4x3/ve.svg?2d66184ba6da6528b7b8a825d3eeb117";